import styled from 'styled-components';
import { themeGet, getTextColor, getPaletteColor } from '@magalu/stereo-ui-styles';
import { ChevronRight, LogoMagalu } from '@magalu/stereo-ui-icons';
import Text from '../../atoms/Text';
export const Label = styled(Text)`
  color: ${props => props.color || getTextColor('scratched')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  margin-right: 4px;
  line-height: ${props => props.lineHeight || `20px`};
`;
export const Link = styled.label`
  color: ${props => getTextColor('base')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  text-decoration: ${({
  disableClick
}) => disableClick ? 'none' : 'underline'};
  cursor: ${({
  disableClick
}) => disableClick ? 'default' : 'pointer'};
`;
export const PartnerLink = styled.a`
  cursor: pointer;

  svg {
    vertical-align: middle;
  }
`;
export const LogoMagaluIcon = styled(LogoMagalu).attrs(props => ({
  color: `${props.logoIconColor || getPaletteColor('base')(props)}`,
  width: 60,
  height: 14,
  viewBox: '0 0 60 14'
}))`
  vertical-align: middle;
  margin-top: 4px;
`;
export const Content = styled.div`
  padding: 15px 15px;
`;
export const Title = styled(Text)`
  font-size: ${props => themeGet('fontSizes.5')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
`;
export const Offers = styled.a`
  height: 20px;
  display: flex;
  align-items: center;
  margin: 28px 0;
  text-decoration: none;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  color: ${props => getTextColor('primary')(props)};
  cursor: pointer;
`;
export const ChevronRightIcon = styled(ChevronRight).attrs(props => ({
  color: getTextColor('primary')(props)
}))`
  vertical-align: middle;
  width: 20px;
  height: 20px;
`;
export const Detail = styled.div`
  margin: 0 0 15px;
`;
export const DetailLabel = styled(Text)`
  font-size: ${props => themeGet('fontSizes.3')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  padding: 0 0 5px;
`;
export const DetailText = styled.p`
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  color: ${props => getTextColor('greyish')(props)};
  padding: 0 0 5px;
`;